import React from 'react';
import styles from './HelpButton.module.scss';

const HelpButton = ({ href, children }) => {
	return (
		<div>
			<a href={href} target="_blank" rel="noreferrer" className={styles.button}>
				{children}
			</a>
		</div>
	);
};

export default HelpButton;
